import androidx.compose.runtime.*
import org.jetbrains.compose.web.dom.*

// Module-level so both the match detail modal and the raw-HTML news feed (RichContent, which can't
// hold Compose state of its own) can open the same fullscreen viewer without threading state
// through the whole App() tree. Compose for Web runs single-threaded (Kotlin/JS), so a bare
// mutableStateOf here is safe.
private var lightboxUrl by mutableStateOf<String?>(null)

fun openLightbox(url: String) {
    lightboxUrl = url
}

/** Mounted once in App() — renders nothing while no photo is open. */
@Composable
fun ImageLightbox() {
    val url = lightboxUrl ?: return
    Div(attrs = {
        classes("modal-backdrop", "lightbox-backdrop")
        onClick { lightboxUrl = null }
    }) {
        Img(src = url, alt = "Zápis o utkání", attrs = {
            classes("lightbox-image")
            onClick { it.stopPropagation() }
        })
        Button(attrs = {
            classes("lightbox-close")
            onClick { lightboxUrl = null }
        }) { Text("✕ Zavřít") }
    }
}
